import React, { useEffect, useState } from 'react';
import { Button, Card, Modal, Nav, Tab } from 'react-bootstrap';
import { FaBan, FaCheck, FaPen, FaTrashAlt } from 'react-icons/fa';
import moment from 'moment';
import AdherentNewUpdate from './AdherentNewUpdate';
import InfoCotisation from './InfoCotisation';
import { formateDate, quoteToDoubleQuote } from './utils/Columns';

const InfoComplete = ({ adherentLight, gotoAuth, reloadData, closeModal }) => {
    const [adherent, setAdherent] = useState({});
    const code = localStorage.getItem('code') || '';
    const url = localStorage.getItem('url') || '';
    const cotisations = JSON.parse(localStorage.getItem('cotisations')) || [];

    useEffect(() => {
        getAdherent();
    }, [adherentLight.id]);

    const handleSaveAdherent = (adh) => {
        let editedAdh = {
            ...adh,
            date_paiement: moment(adh.date_paiement, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            fin_periode: moment(adh.fin_periode, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            enregistre_site_ffc: moment(adh.enregistre_site_ffc, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            enregistre_site_mediation: moment(adh.enregistre_site_mediation, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            date_de_reglement: moment(adh.date_de_reglement, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        };

        fetch(`${url}SaveAdherent/${code}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(quoteToDoubleQuote(editedAdh)).replace(/"Invalid date"/g, '""')
        })
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
                getAdherent();
                handleCloseModal();
                reloadData();
                // if (data === '0' || !data.data)
                //     gotoAuth();
                // else {
                //     setData(data.data);
                //     setDataFiltered(data.data);
                // }
            })
            .catch(error => console.error('Erreur:', error));
    }

    const delAdh = () => {
        if (!window.confirm('Etes vous sur de vouloir supprimer cet adhérent ?')) {
            return;
        }
        fetch(`${url}DelAdherent/${adherentLight.id}/${code}`)
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
                reloadData();
                closeModal();
            })
            .catch(error => console.error('Erreur:', error));
    }

    const getAdherent = () => {
        fetch(`${url}GetAdherentById/${adherentLight.id}/${code}`)
            .then(response => response.json())
            .then(data => {
                if (data === '0' || !data.data)
                    gotoAuth();
                else {
                    let adh = JSON.parse(JSON.stringify({ ...data.data[0] }).replace(/{}/g, '""'));

                    console.log(adh);

                    setAdherent({ ...adh });
                    setEditedAdherent({ ...adh });
                }
            })
            .catch(error => console.error('Erreur:', error));
    }


    const formatDate = (libelle, date) => {
        return date && (
            <p>{libelle}: {formateDate(date)}</p>
        )
    }

    const [activeKey, setActiveKey] = useState('link-0'); // activeKey par défaut

    const tableauData = [
        { key: 'link-0', libelle: 'Adhérent' },
        { key: 'link-1', libelle: 'Effectif' },
        { key: 'link-2', libelle: 'Abonnement' },
        { key: 'link-3', libelle: 'Adhésion' },
        { key: 'link-4', libelle: 'Tribu' },
        { key: 'link-5', libelle: 'SIV' },
        { key: 'link-6', libelle: 'Membre' },
    ];

    const getCotisation = () => {
        let myChoix = cotisations.find(el => el.id === adherent.cotisation_id);
        if (myChoix) {
            console.log("mychoix", myChoix)
            return <InfoCotisation cotisation={myChoix} choix_id={editedAdherent.choix_id} paiement_en_x_fois={editedAdherent.paiement_en_x_fois} />
        }
    }

    const [editedAdherent, setEditedAdherent] = useState({ ...adherent });

    // Modal State
    const [showModal, setShowModal] = useState(false);

    // Function to open modal
    const handleOpenModal = (key) => {
        setActiveKey(key);
        setShowModal(true);
    };

    // Function to close modal
    const handleCloseModal = () => {
        setShowModal(false);
    };

    const blocs = ['infoAdh', 'entreprise', 'effectif', 'abonnement', 'adhesion', 'cotisation', 'tribu', 'siv', 'membre'];
    const champs = [
        { lib: 'civilite', required: false }, { lib: 'prenom_adherent', required: false }, { lib: 'nom_adherent', required: false }, { lib: 'adresse1', required: false }, { lib: 'adresse2', required: false }, { lib: 'code_postal', required: false, longueur: 5 }, { lib: 'ville', required: false }, { lib: 'telephone', required: true }, { lib: 'numero_de_portable', required: false }, { lib: 'e_mail_1', required: true }, { lib: 'e_mail_2', required: false }, { lib: 'e_mail_3', required: false }, { lib: 'numero_de_dpt', required: false }, { lib: 'numero_client', required: false }, { lib: 'region', required: false },

        { lib: 'nom_de_l_entreprise', required: false }, { lib: 'siret', required: true, longueur: 14 }, { lib: 'numero_tva_intracommunautaire', required: false }, { lib: 'code_ape_ou_naf', required: false }, { lib: 'forme_juridique_de_la_societe', required: false }, { lib: 'montant_du_capital', required: false }, { lib: 'code_metier', required: false }, { lib: 'nbre_productifs', required: false }, { lib: 'nbre_apprentis', required: false }, { lib: 'total_personnel', required: false },

        { lib: 'acces_site_ffc_newsletter', required: false }, { lib: 'acces_site_ffc_newsletter', required: false }, { lib: 'abonne_ffc_expert', required: false }, { lib: 'abonne_mag_carrosserie', required: false }, { lib: 'abonne_profession_carrossier', required: false }, { lib: 'acces_mediateur_consommation', required: false },

        { lib: 'reseau', required: false }, { lib: 'adh_depuis', required: true }, { lib: 'annee_de_cotisation', required: false }, { lib: 'date_paiement', required: false }, { lib: 'cotisation_nationale_t1', required: false }, { lib: 'cotisation_reseau', required: false }, { lib: 'cotisation_regionale', required: false }, { lib: 'cotisation_3_ans', required: false }, { lib: 'mode_de_paiement', required: false }, { lib: 'paiement_en_x_fois', required: false }, { lib: 'cnpa', required: false }, { lib: 'fnaa', required: false }, { lib: 'autre', required: false }, { lib: 'cotisation_id', required: false },

        { lib: 'has_tribu', required: false }, { lib: 'date_de_reglement', required: false }, { lib: 'fin_periode', required: false }, { lib: 'montant_tribu_regle_t2', required: false }, { lib: 'moyen_de_paiement', required: false }, { lib: 'paiement_en_x_fois', required: false }, { lib: 'identifiant_tribu', required: false },

        { lib: 'has_siv', required: false }, { lib: 'date_de_reglement_siv', required: false }, { lib: 'fin_periode_siv', required: false }, { lib: 'montant_regle_siv', required: false }, { lib: 'moyen_de_paiement_siv', required: false }, { lib: 'paiement_en_x_fois_siv', required: false },

        { lib: 'membre_bureau_ffc', required: false }, { lib: 'membre_conseil_national', required: false }, { lib: 'membres_conseil_admin', required: false }, { lib: 'titre', required: false },
    ];

    const formatTel = (tel) => {
        if (tel && tel.length === 10) {
            return tel.substring(0, 2) + ' ' + tel.substring(2, 4) + ' ' + tel.substring(4, 6) + ' ' + tel.substring(6, 8) + ' ' + tel.substring(8, 10);
        } else {
            return tel;
        }
    }

    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>

                <h2 width='100%'>
                    <b>{adherent.nom_de_l_entreprise}</b> - {adherent.civilite}. {adherent.prenom_adherent} {adherent.nom_adherent}
                </h2>
                <div style={{ flexGrow: 1 }} />
                <Button variant='light' size='sm' onClick={() => handleOpenModal(activeKey)}><FaPen /></Button>
                <Button variant='outline-danger' size='sm' onClick={delAdh}><FaTrashAlt /></Button>
            </div>
            <Tab.Container activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                <Nav variant="tabs">
                    {tableauData.map((item, index) => (
                        <Nav.Item key={index}>
                            <Nav.Link eventKey={item.key}>{item.libelle}</Nav.Link>
                        </Nav.Item>
                    ))}
                </Nav>
                <Tab.Content>
                    {/* {tableauData.map((item, index) => ( */}
                    <Tab.Pane eventKey='link-0'>
                        <Card>
                            {/* <Card.Header>
                                <div className="d-flex justify-content-between">
                                    <h5>Informations Adhérent</h5>
                                    <div className="d-flex">
                                        <Button variant="outline-secondary" className="mr-2"><FaPen /></Button>
                                        <Button variant="outline-secondary"><FaTrash /></Button>
                                    </div>
                                </div>
                            </Card.Header> */}
                            <Card.Body>
                                <div className='row'>
                                    <div className='col-6'>
                                        <table>
                                            <tr><td>{adherent.civilite}. {adherent.prenom_adherent} {adherent.nom_adherent}</td></tr>
                                            <tr><td>{adherent.adresse1}<br />{adherent.adresse2}<br />{adherent.code_postal}&nbsp;{adherent.ville}</td></tr>
                                            <tr><td>Téléphone 1: {formatTel(adherent.telephone)}</td></tr>
                                            <tr><td>Téléphone 2: {formatTel(adherent.numero_de_portable)}</td></tr>
                                            <tr><td>E-mail 1: {adherent.e_mail_1}</td></tr>
                                            <tr><td>E-mail 2: {adherent.e_mail_2}</td></tr>
                                            <tr><td>E-mail 3: {adherent.e_mail_3}</td></tr>
                                            <tr><td>Numéro de Département: {adherent.numero_de_dpt}</td></tr>
                                            <tr><td>Numéro Client: {adherent.numero_client}</td></tr>
                                            <tr><td>Région: {adherent.region}</td></tr>
                                        </table>

                                    </div>
                                    <div className='col-6'>
                                        <table>
                                            <tr><td>Entreprise: <b>{adherent.nom_de_l_entreprise}</b></td></tr>
                                            <tr><td>Siret: {adherent.siret}</td></tr>
                                            <tr><td>Numéro TVA Intracommunautaire: {adherent.numero_tva_intracommunautaire}</td></tr>
                                            <tr><td>Code APE ou NAF: {adherent.code_ape_ou_naf}</td></tr>
                                            <tr><td>Forme Juridique: {adherent.forme_juridique_de_la_societe}</td></tr>
                                            <tr><td>Montant du Capital: {adherent.montant_du_capital}</td></tr>
                                            <tr><td>Code Métier: {adherent.code_metier}</td></tr>
                                        </table>

                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Tab.Pane>
                    <Tab.Pane eventKey='link-1'>
                        <Card>
                            {/* <Card.Header>
                                <h5>Effectif</h5>
                            </Card.Header> */}
                            <Card.Body>
                                <p>Nombre Productifs: {adherent.nbre_productifs}</p>
                                <p>Nombre Apprentis: {adherent.nbre_apprentis}</p>
                                <p>Total Personnel: {adherent.total_personnel}</p>
                            </Card.Body>
                        </Card>
                    </Tab.Pane>
                    <Tab.Pane eventKey='link-2'>
                        <Card>
                            {/* <Card.Header>
                                <h5>Abonnement</h5>
                            </Card.Header> */}
                            <Card.Body>
                                <p>Accès Site FFC Newsletter: {adherent.acces_site_ffc_newsletter === 0 ? <FaBan style={{ color: 'red' }} /> : <FaCheck style={{ color: 'green' }} />}</p>
                                <p>Abonné FFC Experts: {adherent.abonne_ffc_expert === 0 ? <FaBan style={{ color: 'red' }} /> : <FaCheck style={{ color: 'green' }} />}</p>
                                <p>Abonné Mag Carrosserie: {adherent.abonne_mag_carrosserie === 0 ? <FaBan style={{ color: 'red' }} /> : <FaCheck style={{ color: 'green' }} />}</p>
                                <p>Abonné Profession Carrossier: {adherent.abonne_profession_carrossier === 0 ? <FaBan style={{ color: 'red' }} /> : <FaCheck style={{ color: 'green' }} />}</p>
                                <p>Accès Médiateur Consommation: {adherent.acces_mediateur_consommation === 0 ? <FaBan style={{ color: 'red' }} /> : <FaCheck style={{ color: 'green' }} />}</p>
                                {formatDate('Date enregistré Site FFC', editedAdherent.enregistre_site_ffc)}
                                {formatDate('Date enregistré Site Médiation', editedAdherent.enregistre_site_mediation)}
                            </Card.Body>
                        </Card>
                    </Tab.Pane>
                    <Tab.Pane eventKey='link-3'>
                        <Card>
                            {/* <Card.Header>
                                <h5>Adhésion</h5>
                            </Card.Header> */}
                            <Card.Body>
                                <div className='row'>
                                    <div className='col-6'>
                                        <p>Réseau: {adherent.reseau}</p>
                                        <p>Adhérent Depuis: {adherent.adh_depuis}</p>
                                        <p>Année de Cotisation: {adherent.annee_de_cotisation}</p>
                                        {formatDate('Date de Paiement', editedAdherent.date_paiement)}
                                        {/* <p>Date de Paiement: {adherent.date_paiement}</p> */}
                                        <p>Cotisation Nationale: {adherent.cotisation_nationale_t1}</p>
                                        <p>Cotisation Réseau: {adherent.cotisation_reseau}</p>
                                        <p>Cotisation Régionale: {adherent.cotisation_regionale}</p>
                                        <p>Cotisation 3 Ans: {adherent.cotisation_3_ans}</p>
                                        <p>Mode de Paiement: {adherent.mode_de_paiement}</p>
                                        <p>Paiement en X Fois: {adherent.paiement_en_x_fois}</p>
                                        <p>CNPA: {adherent.cnpa}</p>
                                        <p>FNAA: {adherent.fnaa}</p>
                                        <p>Autre: {adherent.autre}</p>
                                    </div>
                                    <div className='col-6'>
                                        {/* <p>numero_de_feuille_de_cotisation: {adherent.numero_de_feuille_de_cotisation}</p>
                                        <p>ou numero_de_feuille_de_cotisation: {adherent.ou_numero_de_feuille_de_cotisation}</p> */}
                                        {/* {cotisation && <p>Choix Cotisation: {JSON.stringify(cotisation.find(e => e.id === adherent.numero_de_feuille_de_cotisation))}</p>} */}
                                        {getCotisation()}
                                    </div>
                                </div>

                            </Card.Body>
                        </Card>
                    </Tab.Pane>
                    <Tab.Pane eventKey='link-4'>
                        <Card>
                            {/* <Card.Header>
                                <h5>Tribu</h5>
                            </Card.Header> */}
                            <Card.Body>
                                <p>Abonné Tribu O/N: {adherent.has_tribu === 1 ? <FaCheck style={{ color: 'green' }} /> : <FaBan style={{ color: 'red' }} />}</p>
                                {formatDate('Date de Règlement', editedAdherent.date_de_reglement)}
                                {/* <p>Date de Règlement: {adherent.date_de_reglement}</p> */}
                                {formatDate('Fin Période', editedAdherent.fin_periode)}
                                {/* <p>Fin Période: {adherent.fin_periode}</p> */}
                                <p>Montant Tribu Réglé: {adherent.montant_tribu_regle_t2}</p>
                                <p>Moyen de Paiement: {adherent.moyen_de_paiement}</p>
                                <p>Paiement en X Fois: {adherent.paiement_en_x_fois}</p>
                                <p>Identifiant Tribu: {adherent.identifiant_tribu}</p>
                            </Card.Body>
                        </Card>
                    </Tab.Pane>
                    <Tab.Pane eventKey='link-5'>
                        <Card>
                            {/* <Card.Header>
                                <h5>SIV</h5>
                            </Card.Header> */}
                            <Card.Body>
                                <p>Abonné SIV O/N: {adherent.has_siv === 1 ? <FaCheck style={{ color: 'green' }} /> : <FaBan style={{ color: 'red' }} />}</p>
                                {formatDate('Date de Règlement SIV', editedAdherent.date_de_reglement_siv)}
                                {formatDate('Fin Période SIV', editedAdherent.fin_periode_siv)}
                                <p>Montant SIV Réglé: {adherent.montant_regle_siv}</p>
                                <p>Moyen de Paiement SIV: {adherent.moyen_de_paiement_siv}</p>
                                <p>Paiement en X Fois SIV: {adherent.paiement_en_x_fois_siv}</p>
                            </Card.Body>
                        </Card>
                    </Tab.Pane>
                    <Tab.Pane eventKey='link-6'>
                        <Card>
                            {/* <Card.Header>
                                <h5>Membre</h5>
                            </Card.Header> */}
                            <Card.Body>
                                <p>Membre Bureau FFC: {adherent.membre_bureau_ffc === 0 ? <FaBan style={{ color: 'red' }} /> : <FaCheck style={{ color: 'green' }} />}</p>
                                <p>Membre Conseil National: {adherent.membre_conseil_national === 0 ? <FaBan style={{ color: 'red' }} /> : <FaCheck style={{ color: 'green' }} />}</p>
                                <p>Membres Conseil Admin: {adherent.membres_conseil_admin === 0 ? <FaBan style={{ color: 'red' }} /> : <FaCheck style={{ color: 'green' }} />}</p>
                                <p>Titre: {adherent.titre}</p>
                            </Card.Body>
                        </Card>
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
            {/* Modal for displaying content */}
            <Modal
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton />
                <Modal.Body>
                    <AdherentNewUpdate handleSaveAdherent={handleSaveAdherent} blocs={blocs} champs={champs} cotisation={''} setCotisation={() => console.log('rien')} 
                    cotisation2={''} setCotisation2={() => console.log('rien')} adherent={adherent} code={code} url={url} />
                </Modal.Body>
            </Modal>
        </div >
    );
}

export default InfoComplete;
